import { render, staticRenderFns } from "./body-bottom.vue?vue&type=template&id=18e8a466&scoped=true"
import script from "./body-bottom.vue?vue&type=script&lang=js"
export * from "./body-bottom.vue?vue&type=script&lang=js"
import style0 from "./body-bottom.vue?vue&type=style&index=0&id=18e8a466&prod&lang=scss"
import style1 from "./body-bottom.vue?vue&type=style&index=1&id=18e8a466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e8a466",
  null
  
)

export default component.exports